// Time slots: 8:00 AM - 4:30 PM in 30 minute increments
export const times = [
  "8:00 AM", "8:30 AM", "9:00 AM", "9:30 AM",
  "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
  "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM",
  "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM",
  "4:00 PM", "4:30 PM",
];

// Build next 14 bookable dates starting today, skipping Sundays.
// Returns [{iso: "2025-12-22", label: "Today" or "Mon, Dec 22"}]
export function buildDates(count = 14) {
  const out = [];
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  const today = new Date(d);

  while (out.length < count) {
    if (d.getDay() !== 0) {
      const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      const isToday = d.getTime() === today.getTime();
      const label = isToday
        ? `Today, ${d.toLocaleDateString("en-US", { month: "short", day: "numeric" })}`
        : d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
      out.push({ iso, label, isToday });
    }
    d.setDate(d.getDate() + 1);
  }
  return out;
}
